"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEFT = exports.BOTTOM = exports.RIGHT = exports.TOP = exports.Axis = exports.axisPropsFromTickScale = void 0;
var axisPropsFromTickScale_1 = require("./axisPropsFromTickScale");
Object.defineProperty(exports, "axisPropsFromTickScale", { enumerable: true, get: function () { return __importDefault(axisPropsFromTickScale_1).default; } });
var Axis_1 = require("./Axis");
Object.defineProperty(exports, "Axis", { enumerable: true, get: function () { return __importDefault(Axis_1).default; } });
Object.defineProperty(exports, "TOP", { enumerable: true, get: function () { return Axis_1.TOP; } });
Object.defineProperty(exports, "RIGHT", { enumerable: true, get: function () { return Axis_1.RIGHT; } });
Object.defineProperty(exports, "BOTTOM", { enumerable: true, get: function () { return Axis_1.BOTTOM; } });
Object.defineProperty(exports, "LEFT", { enumerable: true, get: function () { return Axis_1.LEFT; } });
//# sourceMappingURL=index.js.map